<template>
  <validation-observer
    ref="form-filing-filer-status"
    tag="div"
  >
    <div class="section">
      <div class="columns">
        <div class="column has-text-centered">
          <h2 class="title is-2">
            Filer Status
          </h2>
          <div class="subtitle is-2">
            Check at least one
          </div>
        </div>
      </div>
      <validation-provider
        v-slot="{ errors, reset }"
        name="Status"
        rules="required"
        class="validate-tooltip"
        mode="eager"
      >
        <div class="columns is-multiline">
          <div
            v-for="fs in filerStatuses"
            :key="fs.id"
            class="column is-4"
          >
            <checkbox-adv
              :id="fs.value"
              v-model="checkedFilerStatuses"
              :value="fs.value"
            >
              {{ fs.description }}
            </checkbox-adv>
          </div>
        </div>
        <transition name="fade">
          <span
            v-if="errors[0]"
            class="shrink error popover"
            @click="reset()"
            v-text="errors[0]"
          />
        </transition>
      </validation-provider>
    </div>
  </validation-observer>
</template>
<script>
import { filerScreenHelpers } from '@/mixins/filerScreen';
import { controlValueHelpers } from '@/mixins/controlValue';
import CheckboxAdv from '@/components/phila-ui/CheckboxAdv';

export default {
  name: 'FilerStatus',
  components: {
    CheckboxAdv,
  },
  mixins: [
    filerScreenHelpers,
    controlValueHelpers,
  ],
  data() {
    return {
      checkedFilerStatuses: [],
      filerStatuses: null,
      filingFilerStatus: null,
    };
  },
  watch: {
    checkedFilerStatuses: {
      async handler () {
        this.$emit('filerStatuses', this.findFilerStatusChanges(this.checkedFilerStatuses));
      },
    },
  },
  async created () {
    await this.initialFetch();
    await this.initialAssign();
    this.$emit('filerStatusesReady', true);
  },
  methods: {
    findFilerStatusChanges () {

      let filerStatuses = {
        post: [],
        delete: [],
      };

      let originalValues = [];

      this.filingFilerStatus.forEach(status => {
        originalValues.push(status.statuses);
        if (!this.checkedFilerStatuses.includes(status.statuses)) {
          filerStatuses.delete.push(status.id);
        }
      });

      this.filerStatuses.forEach(status => {
        if (this.checkedFilerStatuses.includes(status.value) && !originalValues.includes(status.value)) {
          filerStatuses.post.push({ statuses: status.value });
        }
      });

      return filerStatuses;
    },
    getCurrentFilerStatus () {
      if (this.$store.state.filing.currentFilerStatus) {
        return [ ... this.$store.state.filing.currentFilerStatus ];
      }
      return [];
    },
    getFilerStatuses () {
      return [ ...this.$store.getters[ 'admin/activeControlValues' ]('status') ];
    },
    initialAssign () {
      this.filingFilerStatus = this.getCurrentFilerStatus();
      this.filerStatuses = this.getFilerStatuses();
      this.checkedFilerStatuses = this.filingFilerStatus.map(status => {
        return status.statuses;
      });
    },
    async initialFetch () {
      let promises = [];
      promises.push(this.$store.dispatch('admin/getControlValue', 'status'));
      promises.push(this.$store.dispatch('filing/fetchCurrentFilingFilerStatus'));
      await Promise.all(promises);
    },
  },
};
</script>
